import {
  AI_EMPOWERED_INDIVIDUAL_BODY,
  AI_EMPOWERED_INDIVIDUAL_META,
} from "./aiEmpoweredIndividualPost";
import {
  LENDING_RISK_BODY,
  LENDING_RISK_META,
} from "./lendingRiskPost";
import {
  SCIENTIFIC_ART_OF_PM_BODY,
  SCIENTIFIC_ART_OF_PM_META,
} from "./scientificArtOfProductManagementPost";
import { BLOG_POSTS } from "./blogPostsMeta";

export { BLOG_POSTS };

export const BLOG_CATEGORIES = [
  "All",
  "Technology",
  "Photography & Film",
  "Adventure & Travel",
  "People",
];

const BLOG_BODIES = {
  "ai-and-the-rise-of-the-empowered-individual": AI_EMPOWERED_INDIVIDUAL_BODY,
  "risk-calculation-for-lending-is-there-a-simpler-way": LENDING_RISK_BODY,
  "the-scientific-art-of-product-management": SCIENTIFIC_ART_OF_PM_BODY,
};

const BLOG_ARTICLE_META = {
  "ai-and-the-rise-of-the-empowered-individual": AI_EMPOWERED_INDIVIDUAL_META,
  "risk-calculation-for-lending-is-there-a-simpler-way": LENDING_RISK_META,
  "the-scientific-art-of-product-management": SCIENTIFIC_ART_OF_PM_META,
};

/** @param {string} id */
export function getBlogPostBody(id) {
  return BLOG_BODIES[id] ?? null;
}

/** @param {string} id */
export function getBlogArticleMeta(id) {
  return BLOG_ARTICLE_META[id] ?? null;
}

/** @param {string} id */
export function getBlogPostById(id) {
  return BLOG_POSTS.find((post) => post.id === id);
}

/** @param {string} id */
export function getRelatedBlogPosts(id) {
  return BLOG_POSTS.filter((post) => post.id !== id).slice(0, 3);
}

/** @param {string} text @param {string} query */
export function splitHighlight(text, query) {
  const trimmed = query.trim();
  if (!trimmed) return [{ text, match: false }];

  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "ig"));
  return parts.map((part) => ({
    text: part,
    match: part.toLowerCase() === trimmed.toLowerCase(),
  }));
}

/** @param {{ id: string, title: string, cat: string, img: string, date: string, read: string, short: string, blurb: string, kw: string, featured?: boolean }} post @param {string} query */
export function postMatchesQuery(post, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = `${post.title} ${post.cat} ${post.blurb} ${post.kw}`.toLowerCase();
  return haystack.includes(q);
}
